import PropType from "prop-types";
import ZoomGalleryBody from "./zoomGalleryBody";
import { useDispatch, useSelector } from "react-redux";
import ZoomGalleryfooter from "./zoomGalleryfooter";
import ButtonComponent from "../../atoms/button";
import { setDisplayGalleryClickedImage } from "../../../store/slices/pdpSlice";
import { useState } from "react";
import { PRODUCT_VIDEO_POSITION } from "../../../constants/pageConstants/pdpConstants";
/**
 * Component that provides the layout for the add-ons section,
 * including structure for displaying add-ons and managing layout elements.
 *
 * @param {Object} props - The component props.
 * @param {function} props.onClose - Function to handle closing the add-ons section.
 * @returns {JSX.Element} The rendered add-on layout component.
 */
const ZoomGalleryLayout = ({ productImages, productVideoLink }) => {
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(-1);
  const imageDomain = process.env.NEXT_PUBLIC_IMAGE_DOMAIN;

  const galleryClickedImage = useSelector((state) => state.pdp.galleryClickedImage);

  /**
   * Handles the event when the close button is clicked.
   * @returns {void}
   */
  const onCloseButtonClick = () => {
    dispatch(setDisplayGalleryClickedImage({ url: "", index: "" }));
  };

  /**
   * Handles the event when an image is clicked.
   * @param {string} e - The relative path of the clicked image.
   *
   * @returns {void}
   */
  const onImageClick = (imagePath, index) => {
    setActiveIndex(index);
    dispatch(
      setDisplayGalleryClickedImage({
        url: index !== PRODUCT_VIDEO_POSITION || !productVideoLink ? imageDomain + imagePath : imagePath,
        index,
      }),
    );
  };

  return (
    <div className="relative m-0 flex h-[100vh] flex-col overflow-hidden px-16 py-16 md:h-full">
      <div className="absolute right-5 pt-0">
        <ButtonComponent
          buttonVariant="icon"
          icon="/icons/close-circle-black.svg"
          btnParentClasses="flex justify-end"
          onClick={onCloseButtonClick}
          classes="border-0 "
          size="large"
          data_testid="close-btn"
        />
      </div>
      <div className="flex h-[100%] flex-col justify-between md:flex-row md:gap-8">
        <div className={`flex h-[80%] w-[100%] flex-col justify-center overflow-hidden  md:w-[65%]  md:justify-start `}>
          <ZoomGalleryBody
            imageClick={galleryClickedImage?.url}
            productVideoLink={productVideoLink}
            activeIndex={galleryClickedImage?.activeIndex || activeIndex}
          />
        </div>
        <div className="md-px-0 flex gap-14 overflow-x-auto px-8 py-16 md:h-max md:w-[35%] md:flex-wrap  md:pt-32">
          <ZoomGalleryfooter
            productImages={productImages}
            imageClick={galleryClickedImage?.url}
            onImageClick={(imagePath, index) => onImageClick(imagePath, index)}
            productVideoLink={productVideoLink}
          />
        </div>
      </div>
    </div>
  );
};

ZoomGalleryLayout.propTypes = {
  productImages: PropType.array.isRequired,
  productVideoLink: PropType.string,
};

export default ZoomGalleryLayout;
